import { TicketingFormCategory } from "@simplyk/common";

import { useRateContext } from "../Context/RateContext";

export type RateCategoryNoun = "ticket" | "item" | "rate" | "membership" | "registration";

export const useRateCategoryNoun = (): RateCategoryNoun => {
  const { formCategory, isRegistration } = useRateContext();

  if (isRegistration) {
    return "registration";
  }
  switch (formCategory) {
    case TicketingFormCategory.MembershipV2:
      return "membership";
    case TicketingFormCategory.Shop:
    case TicketingFormCategory.Auction:
      return "item";
    case TicketingFormCategory.Event:
    case TicketingFormCategory.Lottery:
      return "ticket";
    case TicketingFormCategory.Sweepstakes:
      return "rate";
    default:
      return "rate";
  }
};
